import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BasicQuery2 from './basicQuery2';
import AdvancedQuery2 from './advancedQuery2';
import {
  ModalDiv,
  Overlay,
} from '../UI/referenceStyles/searchReferenceWrapper';

class SearchReferenceModal extends Component {
  state = {
    mode: 'basic',
  };

  switchToMode = (newMode) => {
    this.setState({
      mode: newMode,
    });
  };

  searchKeysHandler = () => {
    this.setState({ mode: 'search' });
  };

  handleClose = () => {
    const { closeModal } = this.props;
    this.setState({ mode: 'basic' });
    closeModal();
  };

  handleUpdateReference = (output) => {
    const {
      editor: { insertText },
    } = this.props;
    setTimeout(() => insertText(output), 0);
  };

  render() {
    const { isModalOpen } = this.props;
    const { mode } = this.state;
    if (isModalOpen === false) {
      return <div />;
    }

    let currentMode;

    switch (mode) {
      case 'basic':
        currentMode = (
          <BasicQuery2
            switchMode={this.switchToMode}
            closeModal={this.handleClose}
            handleUpdateReference={this.handleUpdateReference}
          />
        );
        break;
      case 'advanced':
        currentMode = (
          <AdvancedQuery2
            switchMode={this.switchToMode}
            closeModal={this.handleClose}
            handleUpdateReference={this.handleUpdateReference}
          />
        );
        break;

      default:
        currentMode = null;
    }

    return (
      <div>
        <ModalDiv isModalOpen={isModalOpen} onClick={this.handleClose} />
        <Overlay>{currentMode}</Overlay>
      </div>
    );
  }
}

SearchReferenceModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  editor: PropTypes.shape({
    resolveController: PropTypes.func,
  }).isRequired,
};

export default SearchReferenceModal;
